<template>
  <div class="content-v2">
    <h3 v-if="displayProfileTitle" class="profile-title">{{ displayProfileTitle }}</h3>
    <div v-if="coverImage" class="profile-cover">
      <img :src="coverImage" :alt="displayProfileTitle || $t('common.profile')" />
    </div>
    <div class="text-v2">
      <div v-html="displayProfileContent"></div>
    </div>
  </div>
</template>

<script>
import { getProfile } from '@/api/portal'
import { resolveFileUrl } from '@/utils/request'

const defaultContent = [
  '山东盛博莱电力工程有限公司成立于2020年，拥有山东盛博莱检测有限公司、济南汶源能源科技有限公司、山东莱创能源有限公司、盛浦（河南）电力工程有限公司、PT SENBOLE POWER ELECTRIC INDONESIA（印度尼西亚）5个全资子公司。',
  '公司现有员工566人，其中职称人员168人，初级职称46人，中级职称112人，高级职称10人。2023年4月15日，中共山东盛博莱电力工程有限公司支部委员会成立。',
  '公司主要从事电力技术咨询、电力调试、电力试验、电力检修、电力维护、培训、电厂托管运营、技术监督、性能试验、热力试验、售电交易、绿电交易、电能优化等业务。',
  '公司拥有多项电力施工、建筑施工、机电工程、承装（修、试）电力设施、电源调试能力、CNAS检验检测、售电业务、安全生产、印尼调试及运维服务许可等资质，并取得20余项技术专利。',
  '盛博莱电力秉承“聚天下英才，创智慧未来”的宗旨，致力打造电力行业一站式综合服务平台。'
].map(item => `<p>${item}</p>`).join('')

const defaultEnglishContent = [
  'Shandong Senbole Power Engineering Co., Ltd. was founded in 2020. The company owns five wholly-owned subsidiaries: Shandong Senbole Testing Co., Ltd., Jinan Wenyuan Energy Technology Co., Ltd., Shandong Laichuang Energy Co., Ltd., Shengpu (Henan) Power Engineering Co., Ltd., and PT SENBOLE POWER ELECTRIC INDONESIA.',
  'The company has 566 employees, including 168 staff members with professional titles. Its services cover power technical consulting, commissioning, testing, overhaul, maintenance, training, plant operation outsourcing, technical supervision, performance testing, power trading, green power consulting and energy optimization.',
  'Senbole Power is committed to building an integrated service platform for the power industry and creating long-term value for customers through professional teams, standardized delivery and reliable project services.'
].map(item => `<p>${item}</p>`).join('')

export default {
  name: 'AboutProfileV2',
  data() {
    return {
      profileTitle: '',
      coverImage: '',
      profileContent: defaultContent
    }
  },
  created() {
    getProfile().then(data => {
      if (!data || !data.profileId) {
        return
      }
      this.profileTitle = data.title || ''
      this.coverImage = resolveFileUrl(data.coverUrl)
      this.profileContent = data.profileContent || this.profileContent
    }).catch(() => {})
  },
  computed: {
    displayProfileTitle() {
      return this.$langState.locale === 'en'
        ? 'Shandong Senbole Power Engineering Co., Ltd.'
        : this.profileTitle
    },
    displayProfileContent() {
      return this.$langState.locale === 'en' ? defaultEnglishContent : this.profileContent
    }
  }
}
</script>

<style lang="scss" scoped>
.profile-title {
  font-size: 28px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 24px;
}

.profile-cover {
  border-radius: 20px;
  overflow: hidden;
  margin-bottom: 32px;
  box-shadow: 0 10px 40px rgba(0,0,0,0.08);

  img {
    width: 100%;
    max-height: 420px;
    object-fit: cover;
    display: block;
  }
}

.text-v2 {
  ::v-deep p {
    text-indent: 2em;
    font-size: 17px;
    line-height: 2.2;
    margin-bottom: 20px;
    color: #475569;
  }
}
</style>
